import React, { Component, lazy, Suspense } from "react";

import { Tabs, TabList, TabPanels, Tab, TabPanel, Box, Text, Wrap, WrapItem, Grid, GridItem, Spacer, Image } from '@chakra-ui/react';
import { format, formatISO } from "date-fns";
const faker = lazy(() => import("@faker-js/faker"));


import { compile } from "mathjs";

import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
const DelSwal = withReactContent(Swal);

import ConfigService from "../../services/ConfigService";
import CoreService from "../../services/CoreService";
import LocalStorageService from "../../services/LocalStorageService";
import IdentityService from "../../services/IdentityService";
//import LocalDbService from "../../services/LocalDbService";
import LocalQueuedDbService from "../../services/LocalQueuedDbService";
import LocalSuspendedDbService from "../../services/LocalSuspendedDbService";

import RoleManager from "../../models/RoleManager.js";
import { AppSecurityKey } from "../../models/AppSecurityKey.js";
import { ObservationSessionMode } from "../../models/ObservationSessionMode.js";


import InitManager from "./Components/Managers/InitManager";
import EnvironmentManager from "./Components/Managers/EnvironmentManager";
import ShapeManager from "./Components/Managers/ShapeManager";
import ScoreManager from "./Components/scorers/ScoreManager";
import PostingManager from "./Components/Managers/PostingManager.js";

import ObservationDebugInfo from "./Components/ObservationDebugInfo";
import FooterButtonStrip from "./Components/FooterButtonStrip";

import BaseCard from "./Components/Cards/BaseCard";
import SlideShowModal from "./Components/SlideShowModal";
import UserImageModal from "./Components/UserImageModal";
import ModalCalculatorDialog from "./Components/Calculator/component/CalculatorModal";
import UserFileModal from "./Components/UserFileModal";
import ScorePreviewModal from "./Components/ScorePreviewModal.jsx";
import JavascriptHelpers from "../../components/lib/Javascript/JavascriptHelpers";
import LookupEntityManager from "./Components/Managers/LookupEntityManager";

import ExpirationTimer from "../../layouts/Home/Components/ExpirationTimer";

import FileManager from "../../managers/FileManager";

import BGJelly from "../../assets/images/swimmingjellies.png";

export default class ObservationPage extends Component 
{
  constructor(props) {
    super(props);

    this.state =
    {
      schema: null,
      activeCard: null,
      activeCardId: null,
      slides: null,
      slideFilter: "",
      showSlides: false,
      showUserImages: false,
      showUserFiles: false,
      showCalculator: false,
      showScorePreview: false,
      originalValueBag: {},
      valueBag: {},
      environBag: {},
      errorBag: {}, // [value.id] = {type: "required", message=""}
      saveLookupEntityBag: {}, // [id]={entityKey: ""} // the value of the card.id
      onChangeEventsBag: {}, // [value.id] = onChangeEvent
      categoryState: {}, // [category.id]=true|false
      requiredState: {}, // [value.id] = {required: true|false, (message="")}
      onChangeEvents: {},
      showDebugInfo: false,
      isProcessing: false

    };

    this.configService = new ConfigService();
    this.coreService = new CoreService();
    this.localStorageService = new LocalStorageService();
    this.localQueuedDbService = new LocalQueuedDbService();
    this.localSuspendedDbService = new LocalSuspendedDbService();
    //this.localObsDbService = new LocalDbService("observation", "obsDb", [{field: "offlineId", name: "offlineId", unique: true}]);

    this.init = this.init.bind(this);
    this.onRefreshEnvironRequest = this.onRefreshEnvironRequest.bind(this);

    this.onToggleCard = this.onToggleCard.bind(this);
    this.onValueChange = this.onValueChange.bind(this);
    this.onValidationChange = this.onValidationChange.bind(this);

    this.onSaveLookupEntity = this.onSaveLookupEntity.bind(this);
    this.onRemoveLookupEntity = this.onRemoveLookupEntity.bind(this);

    this.getSlides = this.getSlides.bind(this);
    this.onShowCardSlides = this.onShowCardSlides.bind(this);
    this.onShowAllSlides = this.onShowAllSlides.bind(this);
    this.onShowUserSlides = this.onShowUserSlides.bind(this);
    this.onCloseCardSlides = this.onCloseCardSlides.bind(this);

    this.onShowUserImages = this.onShowUserImages.bind(this);
    this.onShowCalculator = this.onShowCalculator.bind(this);
    this.onShowUserFiles = this.onShowUserFiles.bind(this);

    this.onSave = this.onSave.bind(this);
    this.onClose = this.onClose.bind(this);
    this.onSuspend = this.onSuspend.bind(this);

    this.processLookupEntities = this.processLookupEntities.bind(this);
    this.completeUpdate = this.completeUpdate.bind(this);


    this.onPreviewScoreRequest = this.onPreviewScoreRequest.bind(this);
    this.onClosePreviewScoreRequest = this.onClosePreviewScoreRequest.bind(this);
    this.onRefreshEnvironRequest = this.onRefreshEnvironRequest.bind(this);
    this.onToggleDebugRequest = this.onToggleDebugRequest.bind(this);

    this.insertSchemaCard = this.insertSchemaCard.bind(this);
    this.removeSchemaCard = this.removeSchemaCard.bind(this);
    this.insertSchemaCardIntoSchema = this.insertSchemaCardIntoSchema.bind(this); // useful for using in init e.g. for inserting userimage cards for update

  }

  onSaveLookupEntity(cardId, cardValue) {
    var newBag = this.state.saveLookupEntityBag;
    newBag[cardId] = { entityKey: cardValue };
    this.setState({ saveLookupEntityBag: newBag });
  }

  onRemoveLookupEntity(cardId) {
    var newBag = this.state.saveLookupEntityBag;
    delete newBag[id];
    this.setState({ saveLookupEntityBag: newBag });
  }


  insertSchemaCard(categoryId, groupTitle, cardSchema) {
    var newSchema = this.state.schema;
    var category = newSchema.categories.find(cat => cat.id === categoryId);
    var group = category.groups.find(grp => grp.groupTitle === groupTitle);
    var cards = group.cards;
    cards.push(cardSchema);
    this.setState({ schema: newSchema });
  }

  insertSchemaCardIntoSchema(schema, categoryId, groupTitle, cardSchema)
  {
    var category = schema.categories.find(cat => cat.id === categoryId);
    var group = category.groups.find(grp => grp.groupTitle === groupTitle);
    var cards = group.cards;
    cards.push(cardSchema);
  }

  removeSchemaCard(categoryId, groupTitle, cardId)
  {
    var newSchema = this.state.schema;
    var category = newSchema.categories.find(cat => cat.id === categoryId);
    var group = category.groups.find(grp => grp.groupTitle === groupTitle);
    var cards = group.cards;
    var cardIndex = cards.findIndex((card) => card.id === cardId);
    cards.splice(cardIndex, 1);
    this.setState({schema: newSchema});
  }


  async componentDidMount() {

    if (this.props.inObservationSession) {
      await this.init();
    }

  }

  async componentDidUpdate(prevProps, prevState) {
    if (prevProps.inObservationSession !== this.props.inObservationSession) {
      console.log("ComponentDidUpdate");
      if (this.props.inObservationSession) {
        await this.init();
      }
    }
  }



  onPreviewScoreRequest(e)
  {
    try 
    {
      this.setState({ isProcessing: true });

      var errorBag = this.validate();
      this.setState({ errorBag: errorBag });
      if (Object.keys(errorBag).length > 0)
      {
        this.setState({ isProcessing: false });
        var errorMessages = Object.keys(errorBag).map((key) => { return '<li key=' + key + '>' + errorBag[key].message + '</li>' }
        );

        var errorHtml = "<ul>" + errorMessages.join(' ') + "</ul>";
        this.props.onMsgBoxRequest("Validation Problem. Unable to Score", '', errorHtml, 'question', 'Yes-Quit', this.onClose, 'Return to Observation');
        return;
      }
      var scoreResult = new ScoreManager().score(this.state.schema, this.state.valueBag);
      this.setState({ 
        score: scoreResult,
        showScorePreview: true
      });
    }
  catch (e) {
    this.props.onMsgBoxRequest("Scoring Problem", e.message, '', 'question', 'Yes-Quit', this.onClose, 'Return to Observation');

  }
  finally {
    this.setState({ isProcessing: false });
  }
  }

  onClosePreviewScoreRequest()
  {
    this.setState({showScorePreview: false});
  }


  async onRefreshEnvironRequest(e) {
    if (this.props.observationSessionMode === ObservationSessionMode.ADD) {
      var environManager = new EnvironmentManager(this.configService.getGeolocationOptions());
      environManager.fetchEnvironment(this.props.userSession.gcid, this.props.userSession.token, this.onValueChange, this.props.onlineInfo).then(() => {
        this.props.onGeolocationStatusUpdateRequest(environManager.environBag["isenabled"]);
        this.setState({ environBag: environManager.environBag });
      });

    }
  }



  async init() {
    // fetch schema
    var schema = await this.localStorageService.getSchema(this.props.currentSchemaId);

    var initialCategoryState = InitManager.initCategoryState(schema, this.props.observationSessionMode);
    var initialRequiredState = InitManager.initRequiredState(schema, this.props.observationSessionMode);
    var initialOnChangeEventsBag = InitManager.initOnChangeEvents(schema, this.props.observationSessionMode);

    var slides = this.getSlides(schema);

    // take "snap"
    var originalValueBag = (this.props.initialValueBag) ? _.cloneDeep(this.props.initialValueBag) : {};
    this.setState({ originalValueBag: originalValueBag });
    var newValueBag = {};

    if ((this.props.observationSessionMode === ObservationSessionMode.ADD) || (this.props.observationSessionMode === ObservationSessionMode.COPY)) {
      var initialValueBag = InitManager.initFreshValueBag(this.props);
      newValueBag = InitManager.initNewValueBag(schema, initialValueBag);
      var environManager = new EnvironmentManager(this.configService.getGeolocationOptions(), this.props.onlineInfo);
      environManager.fetchEnvironment(this.props.userSession.gcid, this.props.userSession.token, this.onValueChange, this.props.onlineInfo).then(() => {
        this.setState({ environBag: environManager.environBag });
      });
      if (this.props.observationSessionMode === ObservationSessionMode.COPY) {
        // overwrite with bag passed in as prop.
        Object.keys(this.props.initialValueBag).forEach(key => {
          newValueBag[key] = this.props.initialValueBag[key];
        });
      }
    }
    else if (this.props.observationSessionMode === ObservationSessionMode.RESUME) 
    {
      newValueBag = this.props.initialValueBag; // all fields
      var userImages = this.props.initialValueBag.userimages;
      FileManager.insertUserImageCards(userImages, schema, false, this.insertSchemaCardIntoSchema);
      var userDocs = this.props.initialValueBag.userdocs;
      FileManager.insertUserDocCards(userDocs, schema, false, this.insertSchemaCardIntoSchema);
    }
    else if (this.props.observationSessionMode === ObservationSessionMode.UPDATE)
    {
      // TBD - look at schema to decide what tabs ARE potentially NOT available
      newValueBag = this.props.initialValueBag; // all fields
      var userImages = this.props.initialValueBag.userimages;
      FileManager.insertUserImageCards(userImages, schema, false, this.insertSchemaCardIntoSchema);
      var userDocs = this.props.initialValueBag.userdocs;
      FileManager.insertUserDocCards(userDocs, schema, false, this.insertSchemaCardIntoSchema);

    }
    else if (this.props.observationSessionMode === ObservationSessionMode.READONLY) 
    {
      // TBD - look at schema to decide what tabs ARE potentially NOT available
      newValueBag = this.props.initialValueBag; // all fields
      // TBD - insert user image and document cards
      var userImages = this.props.initialValueBag.userimages;
      FileManager.insertUserImageCards(userImages, schema, true, this.insertSchemaCardIntoSchema);
      var userDocs = this.props.initialValueBag.userdocs;
      FileManager.insertUserDocCards(userDocs, schema, true, this.insertSchemaCardIntoSchema);
    }
    else if (this.props.observationSessionMode === ObservationSessionMode.DUPLICATE) {
      // overwrite certain fields to represent a NEW observation;
      newValueBag = InitManager.initDuplicateValueBag(this.props, this.props.initialValueBag); // all fields
      // now update environ variables
      var environManager = new EnvironmentManager(this.configService.getGeolocationOptions(), this.props.onlineInfo);
      environManager.fetchEnvironment(this.props.userSession.gcid, this.props.userSession.token, this.onValueChange, this.props.onlineInfo).then(() => {
        this.setState({ environBag: environManager.environBag });
      });
      // note that we do NOT duplicate images or documents.
    }

    this.setState({
      schema: schema,
      valueBag: newValueBag,
      categoryState: initialCategoryState,
      requiredState: initialRequiredState,
      onChangeEventsBag: initialOnChangeEventsBag,
      slides: slides

    });
  }

  onToggleDebugRequest()
  {
    var newShowDebugInfo = (RoleManager.hasRoleRights(AppSecurityKey.DEBUG_OBSERVATION, this.props.userSession.token)) ? (!this.state.showDebugInfo) : false;
    this.setState({showDebugInfo: newShowDebugInfo});
  }

  onToggleCard(card) {
    // if we haven't established an active card yet...
    if (this.state.activeCard === null) {
      this.setState({ activeCard: card, activeCardId: card.id, activeSlideCriteria: card.props.card.criteriaSlides, slideFilter: card.id });
      return;
    }
    // tell the previously-active card to lose focus
    // this.state.activeCard.onLoseFocus();
    // if we haven't CHANGED the card, then don't do anything
    if (this.state.activeCard.props.id === card.props.id) {
      this.state.activeCard.onLoseFocus();
      this.setState({
        activeCard: null,
        activeCardId: null
      });
      return;
    };
    // tell the previously-active card to lose focus
    this.state.activeCard.onLoseFocus();
    // reset the slideFilter back to INDIVIDUAL slides
    this.setState({ activeCard: card, activeCardId: card.id, slideFilter: card.id });
  }

  onValueChange(id, value) {
    console.log("New Value: " + value);
    var newValueBag = this.state.valueBag;
    newValueBag[id] = value;
    console.log("On Value Change: " + id + "=" + value);

    if (id in this.state.onChangeEventsBag) {
      let onChangeEvents = this.state.onChangeEventsBag[id];
      for (var i = 0; i < onChangeEvents.length; i++) 
      {
        // what kind of onchange event type are we dealing with here? Now we have three kinds: 
        // category (tab) state,  required state and recalc state which uses a calc formula
        if (onChangeEvents[i].categoryState) 
        {
          this.onCategoryStateValueChange(id,value, onChangeEvents[i].categoryState);
        }
        if (onChangeEvents[i].requiredState) 
        {
          this.onRequirementStateValueChange(id, value, onChangeEvents[i].requiredState);
        }
        if (onChangeEvents[i].recalcState) 
        {
          this.onRecalcStateValueChange(id, value, onChangeEvents[i].recalcState, newValueBag);
        }
      }
    }

    this.setState({ valueBag: newValueBag });
  }

  onValidationChange(id, isValid, message) {
    var newErrorBag = this.state.errorBag;
    if (isValid) {
      delete newErrorBag[id];
    } else {
      newErrorBag[id] = { required: true, message: message };
    }
    this.setState({ errorBag: newErrorBag });
  }

  validate() 
  {
    var newErrorBag = this.state.errorBag;
    // it's possible that we have required field errors already. Let's clear them before re-checking required state.
    var filteredErrorBag = Object.fromEntries(
      Object.entries(newErrorBag).filter(([k, v]) => v.type !== "required")
    );
    // right now we only have required fields. Check the requiredState to fill the errorbag
    Object.keys(this.state.requiredState).forEach((key) => {
      if (!this.state.valueBag[key]) {
        filteredErrorBag[key] = { type: "required", message: this.state.requiredState[key].message };
      }
    });
    return filteredErrorBag;
  }

  onSetCategoryState(categoryId, enable) 
  {
    var newCategoryState = this.state.categoryState;
    newCategoryState[categoryId] = enable;
    this.setState({ categoryState: newCategoryState });
  }

  onCategoryStateValueChange(id, value, categoryStateChange) 
  {
    // we are changing the state of a category (tab)
    // are we enabling the category state or disabling it? Or maybe we're not changing it at all?
    let newEnabledState = -1; // do nothing.
    if (categoryStateChange.enableOnValue === value) {
      newEnabledState = 1; // turn it ON
    }
    if (categoryStateChange.disableOnValue === value) {
      newEnabledState = 0; // turn it OFF
    }
    if (newEnabledState !== -1) {
      // change it!
      let newCategoryState = this.state.categoryState;
      newCategoryState[categoryStateChange.categoryId] =
        newEnabledState === 1 ? true : false;
      this.setState({ categoryState: newCategoryState });
    }
  }

  onRequirementStateValueChange(id, value, requirementStateChange) 
  {
    let newRequiredState = -1; // do nothing.
    if (requirementStateChange.requiredOnValue === value) {
      newRequiredState = 1; // turn it ON
    }
    if (requirementStateChange.notRequiredOnValue === value) {
      newRequiredState = 0; // turn it OFF
    }
    if (newRequiredState !== -1) {
      // change it!
      let newRequiredStateBag = this.state.requiredState;
      if (newRequiredState === 0) {
        delete newRequiredStateBag[requirementStateChange.targetId];
      }
      if (newRequiredState === 1) {
        newRequiredStateBag[requirementStateChange.targetId] = {
          required: true,
          message: requirementStateChange.message,
        };
      }
      this.setState({ requiredState: newRequiredStateBag });
    }
  }

  onRecalcStateValueChange(id, value, recalcStateChange, newValueBag) {
    const regexp = /\[[^\]]*\]/gm
    const calcFields = [...recalcStateChange.calcFormula.matchAll(regexp)];
    // tbd - test each value to confirm it HAS a value
    // replace each field with its value
    var newCalcFormula = recalcStateChange.calcFormula;
    for (var i = 0; i < calcFields.length; i++) {
      var calcFieldId = toCardId(calcFields[i][0]).replace("[", "").replace("]", "");
      // is this the field we just changed? 
      var calcFieldValue = 0;
      if (toCardId(id) === calcFieldId) {
        calcFieldValue = value;
      } else {
        calcFieldValue = (newValueBag[calcFieldId]) ? newValueBag[calcFieldId] : 0;
      }
      newCalcFormula = newCalcFormula.replace(calcFields[i][0], calcFieldValue);
    }
    // now we have the formula
    const compiledExpression = compile(newCalcFormula);
    var result = compiledExpression.evaluate();
    this.onValueChange(toCardId(recalcStateChange.targetCard), result);
    //newValueBag[toCardId(recalcStateChange.targetCard)] = result;
  }


  

  getSlides(schema) 
  {
    var slides = {};
    if ((schema.schemaSlides?.slides) && (schema.schemaSlides.slides.length > 0)) {
      slides["all"] = schema.schemaSlides.slides;
    }
    for (var i = 0; i < schema.categories.length; i++) {
      for (var j = 0; j < schema.categories[i].groups.length; j++) {
        for (var k = 0; k < schema.categories[i].groups[j].cards.length; k++) {
          if (schema.categories[i].groups[j].cards[k].criteriaSlides) {

            slides[schema.categories[i].groups[j].cards[k].id] = [...schema.categories[i].groups[j].cards[k].criteriaSlides.slides];
          }
        }
      }
    }
    return slides;
  }

  onShowCardSlides() {
    // set slide filter to individual slides
    this.setState({ slideFilter: this.state.activeCardId, showSlides: true });
  }

  onShowAllSlides() {
    this.setState({ slideFilter: "all", showSlides: true });
  }

  onShowUserSlides() {
    this.setState({ slideFilter: "user", showSlides: true })
  }

  onCloseCardSlides() {
    // reset the slide filter to the active card
    this.setState({ slideFilter: this.state.activeCardId, showSlides: false })
  }

  onShowUserImages(show) {
    this.setState({ showUserImages: show });
  }


  onShowUserFiles(show) 
  {
    if (show)
    {
      // stop the lot watcher so that it doesn't interrupt the pdf dialog
      this.props.stopLotWatcher();
    }
    else{
      // restart the lot watcher
      this.props.runLotWatcher();
    }
    this.setState({ showUserFiles: show });
  }

  onShowCalculator(show) {
    this.setState({ showCalculator: show });
  }


  // we have a couple of paths here. The first is checking and prompting for f
  async onSave() 
  {
      this.setState({ isProcessing: true });
      var errorBag = this.validate();
      this.setState({ errorBag: errorBag });
      if (Object.keys(errorBag).length > 0)
      {
        this.setState({ isProcessing: false });
        var errorMessages = Object.keys(errorBag).map((key) => { return '<li key=' + key + '>' + errorBag[key].message + '</li>' }
        );

        var errorHtml = "<ul>" + errorMessages.join(' ') + "</ul>";
        this.props.onMsgBoxRequest("Validation Problems", '', errorHtml, 'question', 'Yes-Quit', this.onClose, 'Return to Observation');
        return;
      }

      var scoreResult = new ScoreManager().score(this.state.schema, this.state.valueBag);
      this.setState({ score: scoreResult });
      let inspectResult = new ShapeManager().shape(this.state.schema, this.state.valueBag);
      this.setState({ observationResult: inspectResult });

      var promptReinspect = PostingManager.allowReinspect(scoreResult.Score.Grade.Weighted, this.state.schema);

      if (promptReinspect)
      {
        var schema = this.state.schema;
        let grade = scoreResult.Score.Grade.Weighted;
        let ttl = schema.scoring.postInspect.reinspect.promptTitle ?? "Reinspect";
        let msg = schema.scoring.postInspect.reinspect.promptMessage.replace("{grade}", grade);
        if (schema.scoring.postInspect.reinspect.requireReinspect)
        {
          DelSwal.fire({ icon: "warning", title: ttl, text: msg });
          return true;
        }
        let confirmLabel = schema.scoring.postInspect.reinspect.confirmButtonLabel ?? "Reinspect";
        let cancelLabel = schema.scoring.postInspect.reinspect.cancelButtonLabel ?? "Score";
        DelSwal.fire
        (
          {
            icon: "question",
            title: ttl,
            text: msg,
            showCancelButton: true,
            confirmButtonText: confirmLabel,
            cancelButtonText: cancelLabel
          }
        ).then(async (result) => 
          {
            //return result.value;
            if (!result.value)
            {
              await this.completeUpdate(inspectResult, scoreResult);
            }
          }
        );
    
      }
      else
      {
        await this.completeUpdate(inspectResult, scoreResult)
      }
  }


  async completeUpdate(inspectResult, scoreResult)
  {
    try
    {
      await this.processLookupEntities();
      var newOfflineId = IdentityService.makeUuid();
      var observation = { data: inspectResult, score: scoreResult, identifiers: { "gcid": this.props.userSession.gcid, "id": this.state.valueBag["originalId"], "offlineId": newOfflineId } };
      var postingManager = new PostingManager(this.state.originalValueBag, this.state.valueBag, this.props.userSession);
      var postResponse;
      if (this.props.observationSessionMode === ObservationSessionMode.UPDATE) 
      {
        postResponse = await postingManager.updateObservation(observation, this.props.userSession);
        if (!postResponse.hasError) this.props.onToastRequest("information", "Observation updated.", 5000, true);
      }
      else 
      {
        postResponse = await postingManager.postPendingObservation(observation, newOfflineId, this.props.onUpdateInQueueCount);
        if (!postResponse.hasError) this.props.onToastRequest("information", "Observation will be posted in the background...", 5000, true);
      }

      if (postResponse.hasError) 
      {
        this.props.onMsgBoxRequest("Posting Problem", result.toMessageString(), '', 'question', 'Yes-Quit', this.onClose, 'Return to Observation');
      }
      // tbd - if resuming suspended, then get rid of suspended!
      this.props.onHomePageRequest();

    }
    catch (e) 
    {
      this.props.onMsgBoxRequest("Posting Problem", e.message, '', 'question', 'Yes-Quit', this.onClose, 'Return to Observation');
    }
    finally 
    {
      this.setState({ isProcessing: false });
    }
  }



  async processLookupEntities()
  {
     // deal with any lookup entities we need to save. There should NOT be any if we are offline.
     var lookupEntities = LookupEntityManager.toLookupEntityList(this.state.saveLookupEntityBag, this.state.valueBag, this.state.schema, this.props.userSession.gcid, this.props.userSession.uid);
     for (const entity of lookupEntities) 
     {
       var response = await this.coreService.postLookupEntity(entity, this.props.userSession.gcid, this.props.userSession.token);
       // tbd what do we do if there is an error?
     }
  }




  async onSuspend() {
    try {
      this.setState({ isProcessing: true });
      var suspendedId = IdentityService.makeUuid();
      var dtTimeTag = format(new Date(), 'hh') + format(new Date(), 'mm');
      var suspendTag = this.state.schema.schemaInfo.id + "-" + faker.animal.type() + "-" + faker.color.human() + "-" + faker.person.lastName() + "-" + dtTimeTag;
      var suspendInfo = { id: suspendedId, suspendTag: suspendTag, suspendedAt: JavascriptHelpers.isoNow(), schemaId: this.state.schema.schemaInfo.id };
      //var suspendedObservation = { valueBag: this.state.valueBag, identifiers: { id: suspendedId, suspendTag: suspendTag, suspendedAt: JavascriptHelpers.isoNow(), schemaId: this.state.schema.schemaInfo.id } };
      var suspendValueBag = this.state.valueBag;
      suspendValueBag.suspendInfo = suspendInfo;
      var result = await this.localSuspendedDbService.addObservation(this.props.userSession.gcid, suspendValueBag, suspendTag);
      if (result.hasError) {
        this.props.onMsgBoxRequest("Suspend Problem", result.toMessageString(), '', 'question', 'Quit', this.onClose, 'Return');
      }
      var allSuspendedTagsResponse = await this.localSuspendedDbService.fetchAllSuspendedTags();
      this.props.onSuspendedObservationChange(allSuspendedTagsResponse.data);
      this.props.onToastRequest("information", "Observation has been suspended. You can continue the observation by selecting " + suspendTag + " from Resume", 15000, true);
      this.props.onHomePageRequest();

    }
    finally {
      this.setState({ isProcessing: false });
    }
  }



  onClose(includeToast = true) 
  {
    this.setState({ isProcessing: false });
    if (includeToast)
    {
      this.props.onToastRequest('ok', 'Observation entry cancelled', 5000, true);
    }
    this.props.onHomePageRequest();
    return;
  }





  render() {
    var colSpan = 1;
    return this.props.userSession.currentSchemaId && this.props.inObservationSession && this.state.schema ? (
      <div >

        <span id="modalDialogsHere">
          <SlideShowModal
            cardId={this.state.activeCardId}
            gcid={this.props.userSession.gcid}
            show={this.state.showSlides}
            close={this.onCloseCardSlides}
            criteriaSlides={this.state.slides}
            valueBag={this.state.valueBag}
            slideFilter={this.state.slideFilter}
            onToastRequest={this.props.onToastRequest}
          />

          <UserImageModal
            show={this.state.showUserImages}
            gcid={this.props.userSession.gcid}
            token={this.props.userSession.token}
            cardId={this.state.activeCardId}
            valueBag={this.state.valueBag}
            onRequestCameraDialogClose={this.onShowUserImages}
            onValueChange={this.onValueChange}
            onInsertSchemaCard={this.insertSchemaCard}
          />



        
          <UserFileModal
            show={this.state.showUserFiles}
            gcid={this.props.userSession.gcid}
            token={this.props.userSession.token}
            cardId={this.state.activeCardId}
            valueBag={this.state.valueBag}
            onRequestClose={this.onShowUserFiles}
            onValueChange={this.onValueChange}
            onInsertSchemaCard={this.insertSchemaCard}
          />



          <ModalCalculatorDialog
            show={this.state.showCalculator}
            cardId={this.state.activeCardId}
            onRequestCalculatorDialogClose={this.onShowCalculator}
            onHide={this.onShowCalculator}
            onValueChange={this.onValueChange}
          />

          <ScorePreviewModal
            show={this.state.showScorePreview}
            close={this.onClosePreviewScoreRequest}
            score={this.state.score}
          />


        </span>


        <div id="tabs">
          
          <Tabs id="schema-categories" size='lg' marginBottom="10vh">
            <TabList style={{ position: "sticky", top: 0, left: 0, zIndex: 999, overflow: "hidden" }}>
            <Image src={BGJelly} position={"absolute"} zIndex={-999} top="-200"/>
              {this.state.schema.categories.map((category, index) =>
              (
                <Tab  color={"white"} _selected={{color: "#1AE59B"}} key={category.id} id={category.id} isDisabled={!this.state.categoryState[category.id]}>{(category.label) ? category.label: category.title}</Tab>
              ))
              }
              <Spacer />
              <Text color={"white"} fontSize={"24px"}>{this.props.userSession.currentSchemaId}</Text>
              <Spacer/>
              <Box margin="10px">
                <ExpirationTimer
                  expires={this.props.sessionExpiration}
                  alertSecondsLeft={this.props.alertSecondsLeft}
                  expireSecondsLeft={this.props.expireSecondsLeft}
                  onExpiredToken={this.props.onExpiredToken}
                  onlineInfo={this.props.onlineInfo}
                />
              </Box>

            </TabList>

            <TabPanels>
              {this.state.schema.categories.map((category) =>
              (
                <TabPanel id={category.id + "-panel"}>
                  {category.groups.map((group) =>
                  (

                    <div key={group.title} id={group.title} className="group-title" style={{ borderTopStyle: "solid", fontSize: "23px", borderColor: "#0095c8", borderBottomWidth: "thick", display: 'flex', flexDirection: 'column', marginBottom: '2vh' }}>
                      <Text fontSize={{ base: '18px', md: '28px', lg: '36px' }} >{(group.label)? group.label : group.groupTitle}</Text>
                      <Box >
                        {

                          <Grid templateColumns='repeat(auto-fit, minmax(340px,1fr))' gap='6' marginBottom='20px'>
                            {group.cards.map((card, index) => {
                              if (this.props.observationSessionMode === ObservationSessionMode.READONLY)
                              {
                                card.disallowToggle = true; // makes it readonly
                              }
                              return (
                              <GridItem colSpan={(card.colspan) ? card.colspan : 1}>
                                <BaseCard
                                  card={card}
                                  id={card.id}
                                  valueBag={this.state.valueBag}
                                  lookupEntityBag={this.state.saveLookupEntityBag}
                                  userSession={this.props.userSession}
                                  schema={this.state.schema}
                                  onlineInfo={this.props.onlineInfo}
                                  observationSessionMode={this.props.observationSessionMode}
                                  onToggleCard={this.onToggleCard}
                                  onValueChange={this.onValueChange}
                                  onValidationChange={this.onValidationChange}
                                  onShowCardSlides={this.onShowCardSlides}
                                  insertSchemaCard={this.insertSchemaCard}
                                  removeSchemaCard={this.removeSchemaCard}
                                  onShowCalculator={this.onShowCalculator}
                                  onShowUserImages={this.onShowUserImages}
                                  onShowUserFiles={this.onShowUserFiles}
                                  onSaveLookupEntity={this.onSaveLookupEntity}
                                  onRemoveLookupEntity={this.onRemoveLookupEntity}
                                  onMsgBoxRequest={this.props.onMsgBoxRequest}
                                />
                              </GridItem>
                              )})}
                          </Grid>

                        }
                      </Box>

                    </div>


                  ))
                  }
                </TabPanel>

              ))}

            </TabPanels>
          </Tabs>
        </div>




        <div id="footerbuttonstrip" style={{ position: "fixed", bottom: 0, width: "100%", marginBottom: ".5vw" }}>
          <Suspense fallback={<div>Loading...</div>}> 
          <FooterButtonStrip
            userSession={this.props.userSession}
            onMsgBoxRequest={this.props.onMsgBoxRequest}
            observationSessionMode={this.props.observationSessionMode}
            onPreviewScoreRequest={this.onPreviewScoreRequest}
            onRefreshEnvironRequest={this.onRefreshEnvironRequest}
            onViewSlidesRequest={this.onShowAllSlides}
            onViewUserImagesRequest={this.onShowUserSlides}
            onSaveRequest={this.onSave}
            onCloseRequest={this.onClose}
            onSuspendRequest={this.onSuspend}
            onShowUserFiles={this.onShowUserFiles}
            onToggleDebugRequest={this.onToggleDebugRequest}
          />
          </Suspense>
        </div>


      {
      this.state.showDebugInfo &&
        <ObservationDebugInfo
          debugObservation={this.props.debugObservation}
          observationSessionMode={this.props.observationSessionMode}
          valueBag={this.state.valueBag}
          environBag={this.state.environBag}
          errorBag={this.state.errorBag}
          categoryState={this.state.categoryState}
          requiredState={this.state.requiredState}
          observationResult={this.state.observationResult}
          score={this.state.score}
          onChangeEventsBag={this.state.onChangeEventsBag}
          schema={this.state.schema}
        />
        }


      </div >
    ) : (
      <div>"Loading..."</div>
    );
  }
}


